<script>
/**
 * ****************************************************************************
 * @description     :   FaqLayout
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import './style.scss';

/**
 * import template
 */
import template from './template.html';
import helpers from '@/utils/helpers';
import store from '@/store';
import FaqLayout from '@/shared/faq-layout/store';
// import { mapActions } from 'vuex';
import { FAQ_CONSTANTS } from '@/utils/constants';
/**
 * import component
 */
import Loading from '@/components/loading';
import SearchBox from '@/views/faq/component/search-box';
import ModalMessage from '@/shared/modal-message';
/**
 * Define faq layout
 */
export default {
    name: 'FaqLayout',
    template: template,
    components: {
        Loading,
        SearchBox,
        ModalMessage
    },
    beforeCreate() {
        if (!store.hasModule('FaqLayout')) {
            store.registerModule('FaqLayout', FaqLayout);
        }
    },
    data() {
        return {
            logoHeader: require('@/assets/images/faq/logoHeader.svg'),
            GMLogo: require('@/assets/images/faq/GMLogo.png'),
            logoHeaderMobile: require('@/assets/images/faq/header_logo2.svg'),
            logoFooter: require('@/assets/images/faq/logoFooter.svg'),
            isScrolled: false,
            showSearchArea: false,
            isOpen: false,
            listCategories: [],
            HELP_CENTER_TITLE: FAQ_CONSTANTS.HELP_CENTER_TITLE
        };
    },
    watch: {
        isOpen(val) {
            if (val) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        }
    },
    computed: {
        // Get additional header class from route
        headerClass() {
            return this.$route?.meta?.layoutProps?.headerClass || '';
        },
        headerTitle() {
            return this.$route?.meta?.title || '';
        },
        isMobile() {
            return helpers.checkIfMobile();
        }
    },
    mounted() {
        this.initializeData();
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        // ...mapActions('FaqLayout', ['fetchHelpCategories']),
        async initializeData() {
            try {
                // Fetch all data at the same time
                // const [dataHelpCategories] = await Promise.all([
                //     this.fetchHelpCategories()
                // ]);
                // Mark data as initialized
                // this.listCategories = dataHelpCategories;
            } catch (error) {
                console.error('Error initializing data:', error);
            }
        },

        handleScroll() {
            this.isScrolled = window.scrollY >= 110;
            if (this.isScrolled) {
                this.showSearchArea = true;
            } else {
                this.showSearchArea = false;
            }
        },

        navigateToSearch(query) {
            if (query && query.trim()) {
                this.$router.push({
                    path: '/CUS_FAQ/searchKeyword',
                    state: { keyword: query, page: 1 }
                });
            }
        }
    }
};
</script>
